import { Grid, Container } from '@mui/material';
import TopNavLink from './TopNavLink';

const TopNavContainer = ({ navCmsHeaderData }) => (
  <Container>
    <Grid
      container
      sx={{ display: { xs: 'flex', md: 'flex' } }}
      justifyContent={{ xs: 'flex-end', sm: 'space-between' }}
      alignItems='center'
    >
      <Grid item sm='auto' sx={{ display: { xs: 'none', md: 'unset' } }}>
        <TopNavLink links={navCmsHeaderData} leftLink />
      </Grid>
      <Grid item sm='auto'>
        <TopNavLink links={navCmsHeaderData} />
      </Grid>
    </Grid>
  </Container>
);

export default TopNavContainer;
